import Vue from "vue";
import alert from "./alert.vue";
import datePicker from "./datepicker.vue";
import header from "./header.vue";

Vue.component('dw-alert', alert);
Vue.component('dw-date-picker', datePicker);
Vue.component('dw-header', header);